import AdUnit from '../../core/AdUnit';

import { getRandomString, getTopURL, logOnServerDebugInfo } from '../../utils/utils';
import { ADMAN_URL, AdvIDPrefix, AdUnitStatus, event, Platform, ContentType } from '../../utils/const';
import LibLoader from "../../utils/LibLoader";

class AdMan extends AdUnit {
  constructor(cfg) {
    super(cfg);

    this.player = null;
    this.prefix = cfg.params.platform === Platform.ADMAN ? 'AdMan' : 'AdManVK';

    this.iframe = null;
    this.scope = cfg.scope;
    this.window = window;
    // this.scope = window;

    // window.addEventListener('message', this._onMessage);

    this.prepare();
  }

  _onMessage = (evt) => {
    try {
      const { data } = evt;

      if (data?.initiator === 'render-runner') {
        // console.log('catch render-runner message', data);
        this.iframe && this.iframe.contentWindow.postMessage(data);
      }
    } catch(e) {
      console.log('err: ', e);
    }
  }

  async prepare() {
    if (!this.scope) { // this.config.params.vpaid === 0
      if (!(window.AdManSDK)) {
        this.logger.log(`AdMan script load`);
        // return injectScript(ADMAN_URL, () => this._init());
        return LibLoader.load(ADMAN_URL,
          () => this.init(),
          (e) => {
            this.logger.log(`[${this.prefix}] error during load library`);
            this.localEmitter.emit(event.Ad.AdError, { code: 9 });
          }
        );
      } else {
        this.slot.style.maxHeight = 'var(--vads-adman-max-height)';

        this.init();
      }
    } else {
      window.addEventListener('message', this._onMessage);

      this.slot.remove();

      this.inFrame = true;
      this.slot = this.scope.getIFrame();

      if (!this.scope.ready) {
        this.scope.subscribe(() => { this.window = this.slot.contentWindow; this.init() });
      } else {
        this.window = this.slot.contentWindow; // TODO: move to init?
        try {
          this.init();
        } catch(e) {
          // console.log('error here', e);
          if (this.inFrame) this.emitter.emit(event.Player.RefreshIFrameScope, { scopeName: this.scope.prefix });
          // this.status = AdUnitStatus.ERROR;
          // return this.emitter.emit(event.Player.RefreshYandexRTBScope);
        }
      }
    }
  }

  init = () => {
    this.logger.log(`[${this.prefix} - ${this.config.playerConfig.zone} / ${this.config.params.tid}] _init() called`, this.config);

    this.advID = AdvIDPrefix.ADMAN + getRandomString();

    if (this.window.frameElement) {
      this.scope.addSlot(this.advID);
    } else {
      this.slot.id = this.advID;
    }
    // this.slot.id = this.advID;

    this.status = AdUnitStatus.LOADED;
  }

  start() {
    this.logger.log(`[${this.prefix} - ${this.config.playerConfig.zone} / ${this.config.params.tid}] start() called`);

    this._startTimestamp = Date.now();

    this.timers.startAd = setTimeout(() => {
      this.logger.log(`[${this.prefix} - ${this.config.playerConfig.zone} / ${this.config.params.tid}] startAd timeout`);
      clearTimeout(this.timers.durationAd);
      this.localEmitter.emit(event.Ad.AdError, { code: 2 });
    }, this.config.timeouts.admanstart || 5000);
    this.timers.durationAd = setTimeout(() => {
      this.logger.log(`[${this.prefix} - ${this.config.playerConfig.zone} / ${this.config.params.tid}] durationAd timeout`);
      this.localEmitter.emit(event.Ad.AdError, { code: 3 });
    }, 45000);

    const dataAdQuery = new URLSearchParams({ dl: getTopURL() }); // window.location.href
    if (this.config.playerConfig.content.type === ContentType.STREAM) dataAdQuery.append('content_id', this.config.content.getID());

    const { template } = this.config;
    const adManSlot = JSON.parse(template).slot;
    const adManConfig = {
      // container: this.config.params.vpaid === 0 ? `#${this.advID}` : '#adman',
      container: `#${this.advID}`,
      slot: adManSlot,
      dataAdQuery: dataAdQuery.toString(),
      onError: ({ error }) => {
        this.logger.log(`[${this.prefix}] Error:`, error);

        // clearTimeout(this.timers.startAd);
        // this.timers.startAd = null;

        clearTimeout(this.timers.durationAd);

        const code = typeof error === 'number' ? error : error.error;
        const isNoAds = code === 1100 || code === 351 || code === 321;
        this.localEmitter.emit(event.Ad.AdError, { code: isNoAds ? 1 : 5 });
      },
      onReady: () => {
        this.logger.log(`[${this.prefix}] onReady`);

        // this.slot.style.zIndex = 6;

        // this.slot.classList.add('active');

        this.emitter.emit(event.Player.PlayerVisibilityChangeRequest, true);
        this.emitter.emit(event.Player.ExpandRequest);

        if (this.player) this.player.start();
      },
      onStarted: () => {
        this.logger.log(`[${this.prefix}] onStarted`);

        this.localEmitter.emit(event.Ad.AdVideoStart);
        this.localEmitter.emit(event.Ad.AdImpression);
      },
      onPlayed: () => {
        this.logger.log(`[${this.prefix}] onPlayed`);
      },
      onClicked: () => {
        this.logger.log(`[${this.prefix}] onClicked`);
      },
      onCompleted: () => {
        this.logger.log(`[${this.prefix}] onCompleted`);
        clearTimeout(this.timers.durationAd);
        this.localEmitter.emit(event.Ad.AdVideoComplete);
      },
    };

    // this.slot.classList.add('active');

    const { platform } = this.config.params;

    try {
      if (platform === Platform.ADMAN) {
        this.window.AdManPlayer(adManConfig);
      } else if (platform === Platform.VK) {
        this.player = new this.window.AdManSDK();
        this.player.init(adManConfig);
      }
    } catch(e) {
      if (this.inFrame) this.emitter.emit(event.Player.RefreshIFrameScope, { scopeName: this.scope.prefix });
    }
  }
}

export default AdMan;
